import { SxProps, Theme } from "@mui/material";

export const formControlStyles: SxProps<Theme> = {
  minWidth: 200,
  mb: 2,
  mt: 2,
};

export const formControlFocusStyles: SxProps<Theme> = {
  minWidth: 200,
};

export const selectStyles: SxProps<Theme> = {
  borderRadius: "8px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D450",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
};

export const inputLabelStyles: SxProps<Theme> = {
  color: "#06B6D4",
};

export const menuItemStyles: SxProps<Theme> = {
  fontSize: "14px",
  zIndex: 2001,
};

export const buttonBoxStyles: SxProps<Theme> = {
  display: "flex",
};
